import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProfitAndLossParam, ProfitAndLossReportInfo } from '../model/profit-loss-report.model';
import { environment } from 'src/environments/environment';
import { GlobalService } from '../service/global.service';

@Injectable({
  providedIn: 'root'
})
export class ProfitLossReportService {
    baseurl: string;
    private apiUrl: string; // ปรับ endpoint ตาม backend ที่คุณตั้งไว้
    constructor(private http: HttpClient , private globalService: GlobalService) { 
        this.baseurl = environment.base_api;
        this.apiUrl = this.baseurl + 'ReportAcc/reportAcc/profitAndLoss';
        console.log('ProfitLossReportService initialized with API URL:', this.apiUrl);
        this.globalService.CheckPagingAccessRights();
    }

    getProfitAndLossReport(param: ProfitAndLossParam): Observable<ProfitAndLossReportInfo> {
        return this.http.post<ProfitAndLossReportInfo>(this.apiUrl, param);
    }

    getProjectList(): Observable<any[]> {
        return this.http.get<any[]>(this.baseurl + 'ReportAcc/filter-list'); // ใช้ API เดียวกัน
    }
}
